import Vue from 'vue'
import Vuex from 'vuex'
import initPlugin from './plugins/init'
Vue.use(Vuex)
const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})
export default new Vuex.Store({
  plugins: [initPlugin],
  state: {
    eapi: (window.ELECTRONAPI ? window.ELECTRONAPI : { invoke: () => { return { code: -100, msg: "环境异常", then: (cb) => {cb({code:-100, msg: "环境异常"})} }},bindBy:()=>{} }),
  },
  modules,
})